import {
    IconLayoutDashboard, IconHeartbeat, IconVirus, IconShieldCheck,
    IconUsers, IconNetwork, IconFileInvoice, IconStethoscope,
    IconUser, IconStack2, IconTags, IconDna, IconChartBar,
    IconSettings,
  } from "@tabler/icons-react";

  export const ALL_PAGES = [
    {
      group: "Core",
      color: "blue",
      pages: [
        { key: "dashboard",     label: "Dashboard",        icon: IconLayoutDashboard, route: "/dashboard" },
      ],
    },
    {
      group: "Code Groups",
      color: "purple",
      icon: IconTags,
      pages: [
        { key: "medicalicd",      label: "Medical ICD",      icon: IconVirus,    route: "/code-groups/medicalicd" },
        { key: "medicalactivity", label: "Medical Activity", icon: IconHeartbeat,route: "/code-groups/medicalactivity" },
        { key: "customicd",       label: "Custom ICD",       icon: IconTags,     route: "/code-groups/customicd" },
        { key: "customactivity",  label: "Custom Activity",  icon: IconStack2,   route: "/code-groups/customactivity" },
      ],
    },
    {
      group: "ICD Configuration",
      color: "coral",
      icon: IconVirus,
      pages: [
        { key: "icd-not-covered",          label: "ICD Not Covered",          icon: IconVirus, route: "/icd-not-covered" },
        { key: "icd-not-allowed-principal", label: "ICD Not Allowed Principal ", icon: IconVirus, route: "/icd-not-allowed-principal-diagnosis" },
        { key: "icd-age-gender",            label: "ICD Age and Gender",          icon: IconVirus, route: "/icd-config/age-gender" },
      ],
    },
    {
      group: "Activity Configuration",
      color: "amber",
      icon: IconHeartbeat,
      pages: [
        { key: "activity-not-covered",    label: "Activity Not Covered",    icon: IconHeartbeat,   route: "/activity-not-covered" },
        { key: "activity-age-gender",     label: "Activity Age and Gender",   icon: IconHeartbeat,   route: "/activity-age-gender" },
        { key: "activities-not-allowed",  label: "Activities Not Allowed",  icon: IconHeartbeat,   route: "/activities-not-allowed" },
        { key: "activities-allowed",      label: "Activities Together",     icon: IconHeartbeat,   route: "/activities-allowed" },
        { key: "activity-not-allowed-icd",label: "Activity Not Allowed ICD",icon: IconHeartbeat,   route: "/activity-not-allowed-icd" },
        { key: "activity-pre-approvals",  label: " Activity Pre-Approvals",          icon: IconShieldCheck, route: "/activity-pre-approvals" },
        { key: "activity-supporting-docs",label: "Supporting Docs Submission",     icon: IconFileInvoice, route: "/activity-supporting-docs-submission" },
        { key: "activity-frequency",      label: "Activity Frequency",      icon: IconChartBar,    route: "/activity-frequency" },
        { key: "activity-bundle",         label: "Activity Bundle",          icon: IconStack2,   route: "/activity-bundle" },
      ],
    },
    {
      group: "Configuration Levels",
      color: "teal",
      icon: IconSettings,
      pages: [
        { key: "tpa-payer",     label: "TPA & Payer",      icon: IconUsers,      route: "/tpa-payer" },
        { key: "network-plan",  label: "Network ",      icon: IconNetwork,    route: "/network-plan" },
        { key: "policy",        label: "Policy",            icon: IconFileInvoice, route: "/policy" },
        { key: "specialty",     label: "Specialty",        icon: IconStethoscope, route: "/specialty" },
        { key: "doctor",        label: "Doctor",           icon: IconUser,       route: "/doctor" },
      ],
    },
    {
      group: "Claim Validation",
      color: "green",
      icon: IconShieldCheck,
      pages: [
        { key: "claim-validation",         label: "Claim Validation",      icon: IconShieldCheck, route: "/claim-validation" },
        { key: "bulk-claim-validation",    label: "Bulk Claim Validation", icon: IconShieldCheck, route: "/bulk-claim-validation" },
        { key: "claim-validation-history", label: "Validation History",    icon: IconDna,         route: "/claim-validation-history" },
      ],
    },
  ];
  
  export const ALL_PAGE_KEYS = ALL_PAGES.flatMap((g) => g.pages).map((p) => p.key);

  export const ALWAYS_ENABLED_KEYS = ["dashboard", "medicalicd", "medicalactivity"];
  
  export const CONTROLLABLE_PAGES = ALL_PAGES
    .map((g) => ({
      ...g,
      pages: g.pages.filter((p) => !ALWAYS_ENABLED_KEYS.includes(p.key)),
    }))
    .filter((g) => g.pages.length > 0);